var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 9,
    height: 9,
    rx: 1,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 9.75C21.2353 9.75 23.25 7.73528 23.25 5.25C23.25 2.76472 21.2353 0.75 18.75 0.75C16.2647 0.75 14.25 2.76472 14.25 5.25C14.25 7.73528 16.2647 9.75 18.75 9.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.786 13.9771C18.6335 13.6839 18.3305 13.5 18 13.5C17.6695 13.5 17.3665 13.6839 17.214 13.9771L12.877 21.7841C12.7103 22.0875 12.7077 22.4544 12.87 22.7601C13.0234 23.0575 13.3284 23.2459 13.663 23.2501H22.337C22.6716 23.2459 22.9766 23.0575 23.13 22.7601C23.2923 22.4544 23.2897 22.0875 23.123 21.7841L18.786 13.9771Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85102 13.0342C5.70322 12.8552 5.48318 12.7515 5.25102 12.7515C5.01885 12.7515 4.79881 12.8552 4.65102 13.0342L0.941016 17.4712C0.685921 17.7777 0.685921 18.2227 0.941016 18.5292L4.64902 22.9662C4.79681 23.1453 5.01685 23.2489 5.24902 23.2489C5.48118 23.2489 5.70122 23.1453 5.84902 22.9662L9.55702 18.5292C9.81211 18.2227 9.81211 17.7777 9.55702 17.4712L5.85102 13.0342Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category-icon.f68ccebb2cf9123a29d2fb32823dd907.svg";
export { ForwardRef as ReactComponent };